




































































































































import BaseComponent from '@/components/base-component.vue';
import ShippingQuoteAddressMenuButton from '@/components/shipping/analise/shipping-quote-address-menu-button.vue';
import ShippingQuoteAnaliseForm from '@/components/shipping/analise/shipping-quote-analise-form.vue';
import ShippingQuoteAnaliseHistButton from '@/components/shipping/analise/shipping-quote-analise-hist-button.vue';
import ShippingQuoteRequestForm from '@/components/shipping/quote-request/shipping-quote-request-form.vue';
import ShippingQuoteStatusChip from '@/components/shipping/shipping-quote-status-chip.vue';
import UiAutoCompleteAddress from '@/components/UI/autocomplete-address.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { AnaliseFiltroPagDTO, SITUACOES_SOLICITACOES_PENDENTES } from '@/interfaces/shipping-quote';
import {
  listShippingQuoteAnalise,
  listShippingQuoteClientUnits,
  listShippingQuotePatients,
  listShippingQuoteRequest,
  listShippingQuoteStatuses,
  listShippingQuoteUsers
} from '@/services/shipping-quote';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { SHIPPING_QUOTE_ANALISYS_PATH, SHIPPING_QUOTE_REQUEST_PATH } from '../routes';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiToggleStatus,
    ShippingQuoteStatusChip,
    UiDatePickerRange,
    ShippingQuoteAnaliseForm,
    ShippingQuoteRequestForm,
    ShippingQuoteAnaliseHistButton,
    ShippingQuoteAddressMenuButton,
    UiAutoCompleteAddress
  }
})
export default class ShippingQuoteFilter extends BaseComponent {
  users = [];
  usersLoading = false;
  idLoginSelec = null;

  clientUnits = [];
  clientUnitsLoading = false;
  idClientUnit = null;

  patients = [];
  patientsLoading = false;
  idPatientSelec = null;

  statuses = [];
  statusesLoading = false;
  statusesSelec = [];

  STATUS_ANALISE_PENDENTE = 'PENDENTE';
  STATUS_ANALISE_AGUARDANDO = 'AGUARDANDO';
  statusAnalise = this.STATUS_ANALISE_PENDENTE;

  datasSelec = [];

  endereco = null;
  bolsaMulti = null;

  pagination = new PaginationSyncDTO();
  result = {};
  items = [];
  loading = false;
  error = false;

  showFormFlag = false;
  chaveSelec = null;

  private headers: any = [
    { text: 'Data', value: 'dataInclusao', sortable: true },
    { text: 'Solicitante', value: 'solicitante', sortable: true },
    { text: 'Unidade', value: 'unidade', sortable: true },
    { text: 'Paciente', value: 'paciente', sortable: true },
    { text: 'UF', value: 'endereco.estado', sortable: true },
    { text: 'Cidade', value: 'endereco.municipio', sortable: true },
    { text: 'Tipo de bolsa', value: 'tpBolsaCompartimentada', sortable: true },
    { text: 'Horário de entrega', value: 'horarioLimEntregaDesejado', sortable: false },
    { text: 'Status', value: 'situacao', sortable: false },
    { text: '', value: '', sortable: false, width: '50px' }
  ];

  public multiOptions = [
    { id: null, label: 'Todos' },
    { id: false, label: 'Comum' },
    { id: true, label: 'Multicompartimentada' }
  ];

  analise = false;
  title = '';

  mounted() {
    if (this.$route.meta) {
      this.analise = this.$route.meta.analise;
      this.title = this.$route.meta.title;
    }

    this.loadClientUnits();
    this.loadUsers();
    this.loadPatients();
    this.loadStatuses();

    this.registerLoadSubject();
    if (!this.analise) {
      this.statusesSelec = SITUACOES_SOLICITACOES_PENDENTES;
    }

    this.loadList();

    let k = this.$route.query.k ? this.$route.query.k.toString() : null;
    if (k) {
      if (this.analise) {
        history.replaceState({}, null, SHIPPING_QUOTE_ANALISYS_PATH);
      } else {
        history.replaceState({}, null, SHIPPING_QUOTE_REQUEST_PATH);
      }
      this.showItem(k);
    }
  }

  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangeSearch() {
    if (this.loading) {
      return;
    }
    this.loadList();
  }

  loadStatuses() {
    this.statusesLoading = true;
    listShippingQuoteStatuses().subscribe(
      (res) => {
        this.statuses = res;
      },
      (error) => {
        this.showToastApiError(error);
      },
      () => {
        this.statusesLoading = false;
      }
    );
  }

  loadClientUnits() {
    this.clientUnitsLoading = true;
    listShippingQuoteClientUnits().subscribe(
      (res) => {
        this.clientUnits = res;
      },
      (error) => {
        this.showToastApiError(error);
      },
      () => {
        this.clientUnitsLoading = false;
      }
    );
  }

  loadUsers() {
    this.usersLoading = true;
    listShippingQuoteUsers().subscribe(
      (res) => {
        this.users = res;
        if (!this.isShowSolicitante()) {
          this.headers = this.headers.filter((i) => i.text != 'Solicitante');
        }
      },
      (error) => {
        this.showToastApiError(error);
      },
      () => {
        this.usersLoading = false;
      }
    );
  }

  loadPatients() {
    this.patientsLoading = true;
    listShippingQuotePatients().subscribe(
      (res) => {
        this.patients = res;
      },
      (error) => {
        this.showToastApiError(error);
      },
      () => {
        this.patientsLoading = false;
      }
    );
  }

  loadSubject$: BehaviorSubject<any> = new BehaviorSubject(null);

  public registerLoadSubject() {
    this.loadSubject$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        switchMap((filter) => {
          this.loading = true;
          this.items = [];
          if (this.analise) {
            return listShippingQuoteAnalise(filter);
          } else {
            return listShippingQuoteRequest(filter);
          }
        })
      )
      .subscribe(
        (res) => {
          this.result = res;
          this.items = res.content;
          PaginationSyncDTO.update(this.pagination, res);
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        }
      );
  }

  loadList() {
    this.loading = true;
    this.error = false;
    let filter = new AnaliseFiltroPagDTO();
    filter.idLoginSolicitante = this.idLoginSelec;
    filter.idUnidade = this.idClientUnit;
    filter.idPaciente = this.idPatientSelec;
    filter.dataSolicIni = this.datasSelec && this.datasSelec.length == 2 ? this.datasSelec[0] : null;
    filter.dataSolicFim = this.datasSelec && this.datasSelec.length == 2 ? this.datasSelec[1] : null;
    filter.situacoes = this.statusesSelec;
    filter.statusAnalise = this.statusAnalise;
    filter.bolsaMulti = this.bolsaMulti;
    if (!!this.endereco) {
      filter.estado = this.endereco.estado;
      filter.municipio = this.endereco.municipio;
      filter.bairro = this.endereco.bairro;
      filter.logradouro = this.endereco.logradouro;
      filter.numero = this.endereco.numero;
    }

    filter.update(this.pagination);
    this.loadSubject$.next(filter);
  }

  showItem(chave) {
    this.chaveSelec = chave;
    this.showFormFlag = true;
  }

  newItem() {
    this.chaveSelec = null;
    this.showFormFlag = true;
  }

  onCloseForm() {
    this.showFormFlag = false;
  }

  onSave() {
    this.loadList();
    this.onCloseForm();
  }

  isShowSolicitante() {
    return this.users && this.users.length;
  }
}
